export default __webpack_public_path__ + "static/slide5-62ae42b407a66e08b689636b4509de04.webp";